/**
 * VoidMiner's additions on top of the IPM core (GDD §12). Off while the game
 * mirrors IPM; turn one back on when we diverge. Their code and data stay in
 * place — a flag only stops them running and hides their UI.
 */
export const ADDITIONS = {
  /** Pick one of three galaxy modifiers at each Fold. */
  drifts: false,
  /** Feed crafted items into permanent Foundry bonuses. */
  fittings: false,
  /** Delivery orders on the Market tab that pay Void Shards. */
  contracts: false,
} as const;
